<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Record</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId" :dataset-id="datasetId"></record-select>
        </div>
      </div>

      <div class="form-group form-row" v-if="datasetId">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <button type="button" class="btn btn-block btn-primary" @click="nextRecord(recordId, datasetId)">Next</button>
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('teamName')" class="col-sm-4 col-form-label">Team name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('teamName')" v-model.lazy="teamName">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('country')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country')" v-model.lazy="country">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('firstName1')" class="col-sm-4 col-form-label">First name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('firstName1')" v-model.lazy="firstName1">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('lastName1')" class="col-sm-4 col-form-label">Last name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('lastName1')" v-model.lazy="lastName1">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('firstName2')" class="col-sm-4 col-form-label">First name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('firstName2')" v-model.lazy="firstName2">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('lastName2')" class="col-sm-4 col-form-label">Last name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('lastName2')" v-model.lazy="lastName2">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>

      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternTeamName')" class="col-sm-4 col-form-label">Team name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTeamName')" v-model.lazy="patternTeamName">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternCountry')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternCountry')" v-model.lazy="patternCountry">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternFirstName1')" class="col-sm-4 col-form-label">First name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternFirstName1')" v-model.lazy="patternFirstName1">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternLastName1')" class="col-sm-4 col-form-label">Last name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternLastName1')" v-model.lazy="patternLastName1">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternFirstName2')" class="col-sm-4 col-form-label">First name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternFirstName2')" v-model.lazy="patternFirstName2">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternLastName2')" class="col-sm-4 col-form-label">Last name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternLastName2')" v-model.lazy="patternLastName2">
        </div>
      </div>

    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateData } from '../../utils/index'

  export default {
    name: 'lower-third-athlete',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['teamName', 'country', 'firstName1', 'lastName1', 'firstName2', 'lastName2']),
      ...mapTemplateData(['datasetId', 'recordId']),
      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        patternTeamName: {default: '${countryName}'},
        patternCountry: {default: '${country0}'},
        patternFirstName1: {default: '${firstName0}'},
        patternLastName1: {default: '${lastName0}'},
        patternFirstName2: {default: '${firstName1}'},
        patternLastName2: {default: '${lastName1}'}
        /* eslint-enable no-template-curly-in-string */
      }),
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      datasetColumns () {
        if (!this.dataset) return
        return this.dataset.columns || []
      }
    },
    watch: {
      recordId: function (val) {
        if (!val) return
        let record = this.$store.getters.dataset(this.datasetId).records
          .find(r => r.recordId === val)
        if (!record) return
        record = this.mapRecord(record)
        this.teamName = record.teamName
        this.country = record.country
        this.firstName1 = record.firstName1
        this.lastName1 = record.lastName1
        this.firstName2 = record.firstName2
        this.lastName2 = record.lastName2
      }
    },
    methods: {
      nextRecord (prevRecordId, datasetId) {
        const records = this.$store.getters.datasetRecords(datasetId)
        const index = records.findIndex(p => p.recordId === prevRecordId)
        this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId
      },
      mapRecord (record) {
        const result = {}
        const recordMap = {
          teamName: this.patternTeamName,
          country: this.patternCountry,
          firstName1: this.patternFirstName1,
          lastName1: this.patternLastName1,
          firstName2: this.patternFirstName2,
          lastName2: this.patternLastName2
        }
        for (let k in recordMap) {
          if (!recordMap.hasOwnProperty(k)) continue
          result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
            return record[p1] || ''
          })
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/fig-team-presentation.vue